import { Text, Checkbox } from '@ui-component-library';

import type { KYCStep1Props } from './KYC.types';

export const KYCStep1 = ({ handleToggle, isSelected }: KYCStep1Props) => {

  return (
    <div className="w-full">
      <Text variant="text-lg/leading-normal/medium">Vad är viktigt för dig?</Text>
      <Text variant="text-sm/leading-normal/normal" className="mt-2 text-[#737373]">
        Välj ett eller flera alternativ.
      </Text>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('virkespriserLonsamhet') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('virkespriserLonsamhet')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Virkespriser och lönsamhet</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`virkespriser-lonsamhet-${isSelected('virkespriserLonsamhet')}`}
            name="virkespriser-lonsamhet"
            checked={isSelected('virkespriserLonsamhet')}
            onClick={() => handleToggle('virkespriserLonsamhet')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('fastighetsvarde') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('fastighetsvarde')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Fastighetsvärdet</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`fastighetsvarde-${isSelected('fastighetsvarde')}`}
            name="fastighetsvarde"
            checked={isSelected('fastighetsvarde')}
            onClick={() => handleToggle('fastighetsvarde')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('effektivForvaltning') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('effektivForvaltning')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Effektiv förvaltning
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`effektiv-forvaltning-${isSelected('effektivForvaltning')}`}
            name="effektiv-forvaltning"
            checked={isSelected('effektivForvaltning')}
            onClick={() => handleToggle('effektivForvaltning')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('jaktViltvard') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('jaktViltvard')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Jakt och viltvård
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`jakt-viltvard-${isSelected('jaktViltvard')}`}
            name="jakt-viltvard"
            checked={isSelected('jaktViltvard')}
            onClick={() => handleToggle('jaktViltvard')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('rekreationFriluftsliv') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('rekreationFriluftsliv')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Rekreation och friluftsliv
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`rekreation-friluftsliv-${isSelected('rekreationFriluftsliv')}`}
            name="rekreation-friluftsliv"
            checked={isSelected('rekreationFriluftsliv')}
            onClick={() => handleToggle('rekreationFriluftsliv')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('klimatKolkrediter') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('klimatKolkrediter')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Klimat och kolkrediter
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`klimat-kolkrediter-${isSelected('klimatKolkrediter')}`}
            name="klimat-kolkrediter"
            checked={isSelected('klimatKolkrediter')}
            onClick={() => handleToggle('klimatKolkrediter')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('biologiskMangfald') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('biologiskMangfald')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Biologisk mångfald
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`biologisk-mangfald-${isSelected('biologiskMangfald')}`}
            name="biologisk-mangfald"
            checked={isSelected('biologiskMangfald')}
            onClick={() => handleToggle('biologiskMangfald')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('forebyggaSkador') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('forebyggaSkador')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Förebygga skador
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`forebygga-skador-${isSelected('forebyggaSkador')}`}
            name="forebygga-skador"
            checked={isSelected('forebyggaSkador')}
            onClick={() => handleToggle('forebyggaSkador')}
          />
        </div>
      </div>
    </div>
  );
};
